import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Field } from "@/components/studio/portalKit";
import { GLASS, Section, SerialPicker } from "@/components/studio/RegFields";

export const emptyFilm = () => ({ product: "", vlt: "", glass: [], sqft: "", serial_id: "" });

const FilmRow = ({ f, i, products, set, remove, needSerial, credit }) => {
  const toggle = (g) => set({ ...f, glass: f.glass.includes(g) ? f.glass.filter((x) => x !== g) : [...f.glass, g] });
  return (
    <div data-testid={`film-row-${i}`} className="space-y-3 rounded-lg border border-slate-200 p-3">
      <div className="flex items-center justify-between">
        <p className="text-sm font-semibold text-brand-ink">Film {i + 1}</p>
        {remove && <Button type="button" size="icon" variant="ghost" className="h-9 w-9" onClick={remove} aria-label="Remove film" data-testid={`film-remove-${i}`}><Trash2 className="h-4 w-4 text-slate-400" /></Button>}
      </div>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <Field label="Film product *">
          <Select value={f.product} onValueChange={(v) => set({ ...f, product: v, serial_id: "", vlt: v.match(/\d+\s*%/)?.[0] || f.vlt })}>
            <SelectTrigger data-testid={`film-product-${i}`}><SelectValue placeholder="Choose film" /></SelectTrigger>
            <SelectContent>{products.map((p) => <SelectItem key={p.id} value={p.name}>{p.name}</SelectItem>)}</SelectContent>
          </Select>
        </Field>
        <Field label="VLT % *"><Input data-testid={`film-vlt-${i}`} value={f.vlt} onChange={(e) => set({ ...f, vlt: e.target.value })} placeholder="e.g. 50%" /></Field>
        <Field label="Sqft used *"><Input data-testid={`film-sqft-${i}`} type="number" min="0" value={f.sqft} onChange={(e) => set({ ...f, sqft: e.target.value })} /></Field>
        <SerialPicker brand="Velotint" product={f.product} value={f.serial_id} required={needSerial} credit={credit}
          onChange={(v) => set({ ...f, serial_id: v })} testid={`film-serial-${i}`} />
      </div>
      <div className="flex flex-wrap gap-2">
        {GLASS.map((g) => (
          <button key={g} type="button" data-testid={`film-${i}-glass-${g.replace(/\s/g, "-").toLowerCase()}`} onClick={() => toggle(g)}
            className={`rounded-full border px-3 py-1.5 text-xs font-medium transition-colors ${f.glass.includes(g) ? "border-crimson-500 bg-crimson-50 text-crimson-700" : "border-slate-200 text-slate-600"}`}>{g}</button>
        ))}
      </div>
    </div>
  );
};

export const VelotintFilms = ({ films, setFilms, products, needSerial, credits = {} }) => {
  const list = products.filter((p) => p.category === "Sunfilm");
  return (
    <Section title="Velotint films">
      <p className="text-xs text-slate-500">Add one line per VLT film used (e.g. windscreen 70%, sides 50%, rear 35%). Each film uses its own roll.</p>
      {films.map((f, i) => (
        <FilmRow key={i} f={f} i={i} products={list} needSerial={needSerial} credit={credits[f.serial_id]}
          set={(nf) => setFilms(films.map((x, n) => (n === i ? nf : x)))}
          remove={films.length > 1 ? () => setFilms(films.filter((_, n) => n !== i)) : null} />
      ))}
      <Button type="button" variant="outline" size="sm" data-testid="add-film-btn" onClick={() => setFilms([...films, emptyFilm()])}>
        <Plus className="mr-1 h-3.5 w-3.5" />Add another film
      </Button>
    </Section>
  );
};
